(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(section) {
      var carousel = section.querySelector('[data-carousel="true"]');
      if (!carousel) return;

      var track = carousel.querySelector('.hero__carousel-track');
      if (!track) return;

      var slides = Array.from(track.children).filter(function (el) {
        return !el.classList.contains('overlay');
      });
      var dots = carousel.querySelectorAll('.hero__carousel-dot');
      var speed = parseInt(carousel.getAttribute('data-carousel-speed') || '5000', 10);
      var current = 0;
      var total = slides.length;
      var timer = null;
      var paused = false;

      if (total <= 1) return;

      function goTo(index) {
        current = ((index % total) + total) % total;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
        dots.forEach(function (dot, i) {
          dot.classList.toggle('hero__carousel-dot--active', i === current);
        });
      }

      function next() {
        goTo(current + 1);
      }

      function startTimer() {
        if (timer) clearInterval(timer);
        timer = setInterval(function () {
          if (!paused) next();
        }, speed);
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.getAttribute('data-index'), 10));
          startTimer();
        });
        dot.style.pointerEvents = 'auto';
      });

      carousel.addEventListener('mouseenter', function () { paused = true; });
      carousel.addEventListener('mouseleave', function () { paused = false; });

      // Touch/swipe support
      var touchStartX = 0;
      carousel.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        paused = true;
      }, { passive: true });
      carousel.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          diff > 0 ? next() : goTo(current - 1);
          startTimer();
        }
        paused = false;
      }, { passive: true });

      goTo(0);
      startTimer();
    }

    document.querySelectorAll('.hero-wrapper').forEach(initCarousel);

    // Shopify theme editor support
    document.addEventListener('shopify:section:load', function (e) {
      initCarousel(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
